


















import {Component, Vue} from 'vue-property-decorator';
import QuickLinkItem from './quickLinkTemplates/QuickLinkItem.vue';
import BudgetOrdersQuickLinkItem from './quickLinkTemplates/BudgetOrdersQuickLinkItem.vue';
import {QuickLink} from '../../../build/swagger-code-extranet-api-definition';
import {isMobile, isMobileSafari} from 'mobile-device-detect';
import QuickLinksStoreModule from '../../store/modules/quickLinks.module';
import {getModule} from 'vuex-module-decorators';

@Component({
    components: {
        QuickLinkItem,
        BudgetOrdersQuickLinkItem,
    },
})
export default class MobileNavigationBar extends Vue {
    quicklinkContainerMaxHeight: string = 'none';

    store: QuickLinksStoreModule = getModule(QuickLinksStoreModule, this.$store);

    mounted() {
        const fixQuicklinksPositionForMobileSafari = () => {
            const defaultMaxHeight = 220;
            const isLandscape = window.innerHeight < window.innerWidth;

            if (isLandscape) {
                const containerOffset = isMobileSafari ? window.outerHeight - window.innerHeight : 0;
                this.quicklinkContainerMaxHeight = defaultMaxHeight + containerOffset + 'px';
            } else {
                this.quicklinkContainerMaxHeight = 'none';
            }
        };

        window.addEventListener('load', fixQuicklinksPositionForMobileSafari);
        window.addEventListener('resize', fixQuicklinksPositionForMobileSafari);
    }

    dynamicComponentName(item: QuickLink): string {
        if (item.key) {
            return item.key + 'Item';
        } else {
            return 'QuickLinkItem';
        }
    }

    get showQuickLinks() {
        return isMobile;
    }
}
